import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { useHistory } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Typography } from '@mui/material';
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

import {
    InputAdornment,
    Box,
    Paper,
} from "@mui/material";

// Ícones
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // Banco
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"; // Conta
import LocationCityIcon from "@mui/icons-material/LocationCity"; // Agência
import BusinessIcon from "@mui/icons-material/Business"; // Unidade
import DescriptionIcon from "@mui/icons-material/Description"; // Descrição


import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import Extrato from './extrato';



export default function GerenciarInstituicaoBancaria({ instituicaoBancaria }) {
    const history = useHistory();



    const [openExtrato, setOpenExtrato] = useState(false);

    const handleOpenExtrato = () => {
        setOpenExtrato(true);
    };

    const closeExtrato = () => {
        setOpenExtrato(false);
    };


    const [loading, setLoading] = useState(true);

    const [objetos, setObjetos] = useState(null);

    const [saldoAtual, setSaldoAtual] = useState(0.0);


    async function listar() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get(`v1/protected/financeiro/instituicaobancaria/saldo-final/${instituicaoBancaria.id_instituicao_bancaria}`, {
                headers: headers
            }).then(function (response) {
                setSaldoAtual(response.data.saldo_final)

                setLoading(false);


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }


    useEffect(() => {




        listar();


    }, []);



    function returnDescricaoBanco(banco) {
        if (banco) {
            var texto = banco;
            return texto;
        }
        else
            return '';
    }



    function returnDescricaoUnidade(unidade) {



        var nome = unidade.nome_fantasia;

        var endereco = unidade.logradouro + ", nº " + unidade.numero + ", " + unidade.bairro + ", " + unidade.cidade + " " + unidade.estado + " CEP: " + unidade.cep;


        var texto = "ID: " + unidade.id_unidade + "\nCNPJ: " + unidade.cnpj +
            "\n " + nome + "\n Endereço: " + endereco;
        return texto;
    }


    return (
        <div>


            <Box
                sx={{
                    padding: 1,
                    marginLeft: 1,
                    width: "100%",
                    backgroundColor: "#f9fbfb",
                }}
            >
                <Paper elevation={3} sx={{ padding: 1, borderRadius: 2 }}>
                    <Grid container spacing={3}>
                        {/* Banco */}
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                id="select-banco"
                                options={[]}
                                disableCloseOnSelect
                                getOptionLabel={(banco) =>
                                    returnDescricaoBanco(banco).replace(/<br \/>/g, "\n")
                                }
                                value={instituicaoBancaria.banco}
                                filterOptions={(options, { inputValue }) => {
                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                    return options.filter((grupo) => {
                                        const cotacaoText =
                                            returnDescricaoBanco(grupo).toLowerCase();
                                        return inputKeywords.every((keyword) =>
                                            cotacaoText.includes(keyword)
                                        );
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Banco"
                                        fullWidth
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <AccountBalanceIcon color="primary" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <Box {...props}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: returnDescricaoBanco(option),
                                            }}
                                        />
                                    </Box>
                                )}
                            />
                        </Grid>

                        {/* Agência */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                variant="outlined"
                                name="agencia"
                                label="Agência"
                                required
                                id="agencia"
                                value={instituicaoBancaria.agencia}
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LocationCityIcon color="primary" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        {/* Conta */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                variant="outlined"
                                name="conta"
                                label="Conta"
                                required
                                id="conta"
                                value={instituicaoBancaria.conta}
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AccountBalanceWalletIcon color="primary" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        {/* Unidade Administrativa */}
                        <Grid item xs={12}>
                            <Autocomplete
                                id="select-unidade"
                                options={[]}
                                disableCloseOnSelect
                                getOptionLabel={(unidade) =>
                                    returnDescricaoUnidade(unidade).replace(/<br \/>/g, "\n")
                                }
                                value={instituicaoBancaria.unidade}
                                filterOptions={(options, { inputValue }) => {
                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                    return options.filter((ordem) => {
                                        const cotacaoText =
                                            returnDescricaoUnidade(ordem).toLowerCase();
                                        return inputKeywords.every((keyword) =>
                                            cotacaoText.includes(keyword)
                                        );
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Unidade Administrativa"
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <BusinessIcon color="primary" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <Box {...props}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: returnDescricaoUnidade(option),
                                            }}
                                        />
                                    </Box>
                                )}
                            />
                        </Grid>

                        {/* Descrição */}
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                name="descricao"
                                label="Descrição"
                                required
                                id="descricao"
                                value={instituicaoBancaria.descricao}
                                fullWidth
                                multiline
                                minRows={3}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <DescriptionIcon color="primary" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Box>

            <Grid item xs={12}>
                <Grid container alignItems="center" justifyItems={'center'} spacing={2}>
                    {/* Saldo atual */}
                    <Grid item>
                        
                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            sx={{ color: saldoAtual < 0 ? "error.main" : "success.main", display: 'flex', alignItems: 'center' }}
                        >
                            <AccountBalanceWalletIcon sx={{ mr: 1 }} />
                           Saldo Atual: {saldoAtual?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) || "R$ 0,00"}
                        </Typography>
                    </Grid>

                    {/* Botão Extrato */}
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<ReceiptLongIcon />}
                            onClick={handleOpenExtrato}
                            sx={{ borderRadius: 2, textTransform: "none", fontWeight: "bold" }}
                        >
                            Ver Extrato Bancário
                        </Button>
                    </Grid>
                </Grid>
            </Grid>


            <Dialog open={openExtrato} onClose={closeExtrato} PaperProps={{ style: { maxWidth: '1400px', minWidth: '1200px' } }}>
                <DialogContent>
                    <Extrato instituicaoBancaria={instituicaoBancaria} />
                </DialogContent>
            </Dialog>


        </div >
    );
}


